// Basic Script for handling sidebar menu accordion
/*
let sidebarMenuHeaders = document.querySelectorAll('.sidebar-menu .sidebar-menu__header');
sidebarMenuHeaders.forEach((header) => {
  if (header.parentNode.classList.contains('open')) {
    let submenu = header.nextElementSibling;
    submenu.style.maxHeight = submenu.scrollHeight + 25 + 'px';
  }
  header.addEventListener('click', (e) => {
    e.preventDefault();
    header.parentNode.classList.toggle('open');
    let submenu = header.nextElementSibling;
    if (submenu.style.maxHeight) {
      submenu.style.maxHeight = null;
    } else {
      submenu.style.maxHeight = submenu.scrollHeight + 'px';
    }
  })
})
*/

// Updated Script
document.addEventListener('DOMContentLoaded', () => {
  const sidebarMenuHeaders = document.querySelectorAll('.sidebar-menu .sidebar-menu__header');

  sidebarMenuHeaders.forEach((header) => {
    const submenu = header.nextElementSibling;
    const parentListItem = header.parentNode;

    // Initialize submenu transform and opacity
    if (!parentListItem.classList.contains('open')) {
      submenu.style.transform = 'scaleY(0)';
      submenu.style.opacity = '0';
      submenu.style.height = '0'; // We'll use a fixed height for the animation
    }

    header.addEventListener('click', (e) => {
      e.preventDefault();
      const isOpen = parentListItem.classList.toggle('open');

      if (isOpen) {
        submenu.style.height = submenu.scrollHeight + 'px';
        submenu.style.transform = 'scaleY(1)';
        submenu.style.opacity = '1';
      } else {
        submenu.style.transform = 'scaleY(0)';
        submenu.style.opacity = '0';
        setTimeout(() => {
          submenu.style.height = '0';
        }, 200); // Timeout should match the CSS transition duration
      }
    });
  });
});
